export class Currency {
  total?: any;
  amount?: any;
  amountReserved?: any;
  restrictedBalance?: any;
  availableBalance?: any;
  totalWin?: any;
  totalLoss?: any;
  moneyAtTables?: any;
  pureUSD?: any;
  depositCount?: any;
  totalDepositsAmount?: any;
  totalWithdrawalsAmount?: any;
  bingoBalance?: any;
  label?: any;
  symbol?: any;

  constructor(data: Object = {}) {
    Object.assign(this, data);
  }
}

export class BalanceModel {
  USD?: Currency;
  CAD?: Currency;
  PLAY?: Currency;
  LBPOINTS?: Currency;
  LLTY?: Currency;
  RWP?: Currency;
  BGD?: Currency;
  TD?: Currency;

  DEFAULT_CURRENCY = null;

  constructor(data: any = {}, config) {
    Object.assign(this, data);
    this.setDefaultCurrency(config.DEFAULT_CURRENCY);
  }

  setDefaultCurrency(value) {
    this.DEFAULT_CURRENCY = value;
  }

  getDefaultCurrency() {
    return this.DEFAULT_CURRENCY;
  }

  hasEnrollDate() {
      return this[this.DEFAULT_CURRENCY]['firstDepositDate'];
  }

  getEnrollDate() {
    let enrollDate = null;

    if (this.hasEnrollDate()) {
      enrollDate = new Date(this[this.DEFAULT_CURRENCY]['firstDepositDate']);
    }

    return enrollDate;
  }

  getAvailableBalance() {
    return this[this.DEFAULT_CURRENCY].availableBalance;
  }

  getRealCash() {
    return this[this.DEFAULT_CURRENCY].availableBalance;
  }

  getAmount() {
    return this[this.DEFAULT_CURRENCY].amount;
  }

  getBonus() {
    return this[this.DEFAULT_CURRENCY].bonus;
  }

  getAvailableForWithdrawalBalance() {
    return this[this.DEFAULT_CURRENCY].availableBalance;
  }

  forPlayCasino() {
    return this[this.DEFAULT_CURRENCY].amount;
    /*//sometimes values are recieved as strings, so conversion is needed
    let a = +this[this.DEFAULT_CURRENCY].restrictedBalance
    let b = +this[this.DEFAULT_CURRENCY].availableBalance
    return (
      a +
      b
    );*/
  }

  forPlayRestrictedOnlyCasino() {
    return this[this.DEFAULT_CURRENCY].restrictedBalance  ;
  }

  forPlayPoker() {
    return this[this.DEFAULT_CURRENCY].availableBalance  ;
  }

  playMoneyCasino() {
    return this.PLAY.availableBalance   + this.PLAY.restrictedBalance  ;
  }

  playMoneyPoker() {
    return this.PLAY.availableBalance  ;
  }

  forPlayBingo() {
    if (this.BGD != null && this.BGD.amount != null)
      return (
        this[this.DEFAULT_CURRENCY].availableBalance   +
        parseInt(this.BGD.amount)  
      );
    else return this[this.DEFAULT_CURRENCY].availableBalance  ;
  }

  getBingoDollars() {
    return this.BGD.amount  ;
  }

  getTournamentDollars() {
    return this.TD.amount  ;
  }

  moneyAtTables() {
    return this[this.DEFAULT_CURRENCY].moneyAtTables  ;
  }

  getDepositCount() {
    return this[this.DEFAULT_CURRENCY].depositCount;
  }
  
  getTotalDepositAmount() {
    return this[this.DEFAULT_CURRENCY].totalDepositsAmount  ;
  }

  getWithdrawalCount() {
    return this[this.DEFAULT_CURRENCY].withdrawalCount;
  }
  getTotalWithdrawalAmount() {
    return this[this.DEFAULT_CURRENCY].totalWithdrawalsAmount  ;
  }

  getRestrictedWinning() {
    return this[this.DEFAULT_CURRENCY].restrictedWinning  ;
  }

  getRestrictedTotal() {
    return this[this.DEFAULT_CURRENCY].restrictedTotal  ;
  }

  getRestrictedCash() {
    return this[this.DEFAULT_CURRENCY].restrictedCash  ;
  }

  getRestrictedBonus() {
    return this[this.DEFAULT_CURRENCY].restrictedBonus  ;
  }

  getReservedCash(){
    return this[this.DEFAULT_CURRENCY].amountReserved  ;
  }

  get curencyTitle() {
    let title;
    switch (this.DEFAULT_CURRENCY) {
      case 'PLAY':
        title = 'Playchips';
        break;
      case 'CAD':
      case 'USD':
        title = 'Real Cash';
        break;
    }
    return title;
  }

  get isRealMoney() {
    let result;
    switch (this.DEFAULT_CURRENCY) {
      case 'PLAY':
        result = false;
        break;
      case 'CAD':
      case 'USD':
        result = true;
        break;
    }
    return result;
  }
}
